











import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Icon } from 'vant';

Vue.use(Icon);

@Component
export default class FloatLikeBtn extends Vue {
  @Prop() activePost!: any;
  @Prop() showZan!: any;
}
